/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host([scale=s]) .container {
  block-size: 0.75rem;
}
:host([scale=s]) .track {
  block-size: 0.75rem;
  inline-size: 1.5rem;
}
:host([scale=s]) .handle {
  block-size: 0.5rem;
  inline-size: 0.5rem;
}

:host([scale=m]) .container {
  block-size: 1rem;
}
:host([scale=m]) .track {
  block-size: 1rem;
  inline-size: 2rem;
}
:host([scale=m]) .handle {
  block-size: 0.75rem;
  inline-size: 0.75rem;
}

:host([scale=l]) .container {
  block-size: 1.5rem;
}
:host([scale=l]) .track {
  block-size: 1.5rem;
  inline-size: 3rem;
}
:host([scale=l]) .handle {
  block-size: 1.25rem;
  inline-size: 1.25rem;
}

:host {
  position: relative;
  display: inline-block;
  inline-size: auto;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  tap-highlight-color: transparent;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

.container {
  outline-width: 0px;
}

.track {
  pointer-events: none;
  position: relative;
  box-sizing: border-box;
  display: inline-block;
  border-radius: 9999px;
  border-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-2);
  background-color: var(--calcite-color-foreground-2);
  vertical-align: top;
  outline-color: transparent;
}

.container:focus .track {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

.handle {
  pointer-events: none;
  position: absolute;
  display: block;
  border-radius: 9999px;
  border-width: 2px;
  border-style: solid;
  border-color: var(--calcite-color-border-input);
  background-color: var(--calcite-color-foreground-1);
  transition-property: all;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  inset-block-start: -1px;
  inset-inline: -1px auto;
}

.container:hover .handle,
.container:focus .handle {
  border-color: var(--calcite-color-brand);
  box-shadow: inset 0 0 0 1px var(--calcite-color-brand);
}

:host([checked]) .track {
  border-color: var(--calcite-color-brand-hover);
  background-color: var(--calcite-color-brand);
}
:host([checked]) .handle {
  border-color: var(--calcite-color-brand);
  inset-inline: auto -1px;
}
:host([checked]) .container:hover .handle {
  border-color: var(--calcite-color-brand-hover);
  box-shadow: inset 0 0 0 1px var(--calcite-color-brand-hover);
}

@media (forced-colors: active) {
  :host([checked]) .track {
    background-color: canvasText;
  }
}
::slotted(input[slot=hidden-form-input]) {
  margin: 0 !important;
  opacity: 0 !important;
  outline: none !important;
  padding: 0 !important;
  position: absolute !important;
  inset: 0 !important;
  transform: none !important;
  -webkit-appearance: none !important;
  z-index: -1 !important;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}